"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersReducer = exports.initialState = void 0;
/* Package Imports */
var lodash_1 = __importDefault(require("lodash"));
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var usersActions = __importStar(require("./actions"));
exports.initialState = {
    filteredUsers: [],
    internalUsers: [],
    remoteSources: [],
    userInteractions: [],
    workgroupUsers: [],
    workgroups: []
};
// Minimum number of characters before typeahead loads
var TYPEAHEAD_MIN_LENGTH = 3;
// Maximum numbers of records to display at a time for typeahead
var TYPEAHEAD_MAX_RESULTS = 50;
/* Utility Functions - begin */
var searchEmail = function (email, searchTerm) {
    if (email.startsWith('*')) {
        return email.toLowerCase().includes(searchTerm);
    }
    else {
        return email.toLowerCase().startsWith(searchTerm);
    }
};
var searchSplitName = function (name, searchTerm) {
    var found = false;
    var names = name.split(' ');
    for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
        var n = names_1[_i];
        if (n.startsWith(searchTerm)) {
            found = true;
        }
    }
    if (name.startsWith(searchTerm)) {
        found = true;
    }
    return found;
};
/* Utility Functions - end */
var usersReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        // Users actions
        case typesafe_actions_1.getType(usersActions.getRemoteSourcesSuccess):
            return __assign(__assign({}, state), { remoteSources: action.payload });
        case typesafe_actions_1.getType(usersActions.loadInternalUsersSuccess):
            return __assign(__assign({}, state), { internalUsers: action.payload });
        case typesafe_actions_1.getType(usersActions.loadUserInteractionsSuccess):
            return __assign(__assign({}, state), { userInteractions: action.payload });
        case typesafe_actions_1.getType(usersActions.loadWorkgroupsSuccess): {
            var wgUsers_1 = [];
            if (action.payload.length > 0) {
                action.payload.forEach(function (workgroup) {
                    if (workgroup.can_write) {
                        wgUsers_1.push(workgroup.user);
                    }
                });
            }
            return __assign(__assign({}, state), { workgroups: action.payload, workgroupUsers: wgUsers_1 });
        }
        case typesafe_actions_1.getType(usersActions.queryUsers): {
            var filteredUsers = [];
            var term_1 = (action.payload || '').toLowerCase();
            if (term_1.length >= TYPEAHEAD_MIN_LENGTH) {
                var allUsers = __spreadArray(__spreadArray(__spreadArray([], state.internalUsers), state.userInteractions), state.workgroupUsers);
                var uniqueUsers = lodash_1.default.uniqBy(allUsers, function (u) { return u.email; });
                var sortedUsers = lodash_1.default.orderBy(uniqueUsers, ['name'], ['asc']);
                filteredUsers = sortedUsers.filter(function (u) { return searchEmail(u.email.toLowerCase(), term_1) || searchSplitName(u.name.toLowerCase(), term_1); }).splice(0, TYPEAHEAD_MAX_RESULTS);
            }
            else {
                // If the search term is empty or less than min char length, reset the filtered users to an empty set
                filteredUsers = [];
            }
            return __assign(__assign({}, state), { filteredUsers: filteredUsers });
        }
        default:
            return state;
    }
};
exports.usersReducer = usersReducer;
